import { StartTripModel } from '../../../models/home/StartTrip.model';
import { StopActivityProps, defaultStopActivity } from '../../../models/stopActivity.model';
import { EquipmentFlow, StopInformation } from '../../../schemas/Exicution/exicution.schema';
import { set_depMaxTime, set_depMinTime } from '../../../services/common.services';
import { logEvent, setScreenName } from '../../../utils/Analytics';
import { DB_GPS_ACTIVATED_SHIPMENT, EGPSTrackingStatus, OTHER } from '../../../utils/constants';
import { LoadStopModel } from './loadStopUtil';
import i18n from '../../../../i18n';
import { EVENT } from '../../../utils/constants.analytics';
import { IONICWrapper } from '../../../utils/common';

const startTripModel = new StartTripModel();
const loadStopModel = new LoadStopModel();
const depMinTime = set_depMinTime();
const depMaxTime = set_depMaxTime();

export const updateStopInfo = async (
	props: any, 
	stopDetail: any, 
	TRAILER_IN_ACTIVITY: StopActivityProps | null, 
	TRAILER_OUT_ACTIVITY: StopActivityProps | null, 
	ARRIVAL_VALUE: string, 
	ETA_VALUE: string, 
	DEPARTURE_VALUE: string, 
	TRAILER_IN: string, 
	TRAILER_OUT: string,
	prevStopDepartedDate?: any,
	isLoading?:any,
	trailerWarning?:boolean,
	lateReason?:string | null
	) => {
	const currentDate = new Date(startTripModel.getTimeWithTimezone(stopDetail.timeZone));
	currentDate.setMinutes(currentDate.getMinutes() + depMaxTime);
	const isDepartureReadonly = loadStopModel.isDepartureReadonly(
		stopDetail,
		ARRIVAL_VALUE
	);
	const isArrivalReadonly = loadStopModel.isArrivalReadonly(stopDetail);
	if (
		arrivalDatCheck(ARRIVAL_VALUE, currentDate, isArrivalReadonly)
	) {
		props.onShowError(i18n.t('ARRIVAL_ERROR'));
		logEvent(EVENT.UE_STOP_UPDATE_FAILURE, {
			carrierId: props.carrierId,
			shipmentId: stopDetail.shipmentId,
			stopID: stopDetail.stopId,
			lateReasonCode : lateReason
		});
		return;
	}
	if (
    prevStopDepartedDate &&
    ARRIVAL_VALUE &&
    new Date(prevStopDepartedDate) > new Date(ARRIVAL_VALUE) && !isArrivalReadonly
  ) {
	props.onShowError(i18n.t('DEPARTURE_ARRIVAL_STOP_ERROR'));
	logEvent(EVENT.UE_STOP_UPDATE_FAILURE, {
		carrierId: props.carrierId,
		shipmentId: stopDetail.shipmentId,
		stopID: stopDetail.stopId,
		lateReasonCode : lateReason
	});
	return;
  }

	if (ARRIVAL_VALUE) {
		if (
			isManagedTrailerValidation(TRAILER_IN, props)
		) {
			props.onShowError(i18n.t('TRAILER_IN_ERROR'));
			return;
		}
	}

	if (DEPARTURE_VALUE) {
		const _arrival = arrivalDataValidation(ARRIVAL_VALUE, currentDate);
		const _departure = new Date(DEPARTURE_VALUE);
		if (isDepartureReadOnlyValidation(_departure, currentDate, isDepartureReadonly)) {
			props.onShowError(i18n.t('DEPARTURE_ERROR'));
			return;
		}
		_arrival.setMinutes(_arrival.getMinutes() + depMinTime);
		if (getArrivalReadOnlyValidation(_arrival, _departure, isDepartureReadonly)) {
			props.onShowError(i18n.t('DEPARTURE_ARRIVAL_ERROR'));
			return;
		}
		if (
			isManagedTrailerValidation(TRAILER_IN, props)
		) {
			props.onShowError(i18n.t('TRAILER_IN_ERROR'));
			return;
		}
		if (
			startTripManagedTrailerValidation(TRAILER_OUT, props)
		) {
			props.onShowError(i18n.t('TRAILER_OUT_ERROR'));
			return;
		}
	}
	if (
		TRAILER_OUT &&
		startTripModel.isManagedEquipmentWithTrailerValidation(TRAILER_OUT, props.loadDetails)
	) {
		props.onShowError(i18n.t('VALID_TRAILER_OUT'));
		return;
	}
	if (
		trailerInCheck(TRAILER_IN, props)
	) {
		props.onShowError(i18n.t('VALID_TRAILER_IN'));
		return;
	}
	let trailerIn: StopActivityProps;
	let trailerOut: StopActivityProps;
	const activity: StopActivityProps[] = [];
	trailerIn = getTrailerInValue(stopDetail, trailerINActivityCheck(TRAILER_IN_ACTIVITY), TRAILER_IN);
	trailerOut = getTrailerOutValue(stopDetail, trailerOutActivityCheck(TRAILER_OUT_ACTIVITY), TRAILER_OUT);
	equipmentTrailerIN(trailerIn, activity, trailerOut);

	const stopInfo: StopInformation = {
		carrierPro: '',
		carrierScac: '',
		stopId: stopDetail.stopId,
		sequenceNo: stopDetail.sequenceNo,
		stopNumber: stopDetail.sequenceNo,
		locationId: stopDetail.locationId,
		city: stopDetail.city,
		state: stopDetail.state,
		country: stopDetail.country,
		latitude: getStopDetailLatitude(stopDetail),
		longitude: getStopDetailLongitude(stopDetail),
		timeZone: stopDetail.timeZone,
		positionDateTime: new Date().toISOString(),
		actualArrivalDateTime: ARRIVAL_VALUE,
		actualETADateTime: ETA_VALUE,
		actualDepartureDateTime: DEPARTURE_VALUE,
		stopTrailerActivity: activity,
		carrierId: '',
		shipmentId: stopDetail.shipmentId,
		sourceSystem: stopDetail.sourceSystem,
		userId: '',
		gpsTrackingStatus: props.shipmentToStartTrip.gpsTrackingStatus,
		lateArrivalReason:lateReason
	};
//-----Feature:F30364 - Disabled the functionality to Enable GPS by clicking on CTA button
	// if (isPlatform('capacitor')) {
	// 	stopInfo.gpsTrackingStatus = EGPSTrackingStatus.GPS_TRACKING_NOT_STARTED;
	// 	await getGEOTrackingStatus(props, stopInfo);
	// }
	isLoading && isLoading(true)
	props.changeExpandStop(stopInfo,isLoading,trailerWarning,lateReason);
    props.allowUpdateStop && props.toggleAllowUpdateStop && props.toggleAllowUpdateStop();
	// Analytics implementation
	setScreenName("screen_update_stop");
	logEvent(EVENT.UE_STOP_UPDATE_SUCCESS, {
		carrierId: props.carrierId,
		shipmentId: stopDetail.shipmentId,
		stopID: stopDetail.stopId,
		lateReasonCode : lateReason
	});
};
export const getTrailerInValue = (stopDetail: any, TRAILER_IN_ACTIVITY: StopActivityProps | null, TRAILER_IN: string): StopActivityProps => {
	if (!TRAILER_IN_ACTIVITY) {
		return { ...defaultStopActivity, stopId: stopDetail.stopId };
	}
	return {
		equipmentFlow: EquipmentFlow.TRAILER_IN,
		equipmentId: TRAILER_IN.includes(OTHER) ? TRAILER_IN.slice(5) : TRAILER_IN,
		equipmentOwner: TRAILER_IN_ACTIVITY.equipmentOwner,
		equipmentType: TRAILER_IN_ACTIVITY.equipmentType,
		id: TRAILER_IN_ACTIVITY.id,
		name: TRAILER_IN_ACTIVITY.name,
		stopId: TRAILER_IN_ACTIVITY.stopId,
		execActivity: TRAILER_IN_ACTIVITY.execActivity,
		seqNo: TRAILER_IN_ACTIVITY.seqNo,
		tmsActivity: TRAILER_IN_ACTIVITY.tmsActivity,
	};
};

export const getTrailerOutValue = (stopDetail: any, TRAILER_OUT_ACTIVITY: StopActivityProps | null, TRAILER_OUT: string): StopActivityProps => {
	if (!TRAILER_OUT_ACTIVITY) {
		return { ...defaultStopActivity, stopId: stopDetail.stopId };
	}
	return {
		equipmentFlow: EquipmentFlow.TRAILER_OUT,
		equipmentId: TRAILER_OUT.includes(OTHER) ? TRAILER_OUT.slice(5) : TRAILER_OUT,
		equipmentOwner: TRAILER_OUT_ACTIVITY.equipmentType,
		id: TRAILER_OUT_ACTIVITY.id,
		name: TRAILER_OUT_ACTIVITY.name,
		stopId: TRAILER_OUT_ACTIVITY.stopId,
		equipmentType: TRAILER_OUT_ACTIVITY.equipmentType,
		execActivity: TRAILER_OUT_ACTIVITY.execActivity,
		seqNo: TRAILER_OUT_ACTIVITY.seqNo,
		tmsActivity: TRAILER_OUT_ACTIVITY.tmsActivity,
	};
};

export const validatingTrailerInput: { [key: string]: (input: string) => string } = {
	TA: (input: string) => input.replace(/[^0-9]*/g, ''),
	SNLU: (input: string) => input.replace(/[^0-9]*/g, ''),
	SNCZ: (input: string) => input.replace(/[^0-9]*/g, ''),
	BOBTAIL: (input: string) => input,
	OTHER: (input: string) => input
}

export const restrictAlphaonKeyPress = (event:any) => {
	if(/[a-z]/i.test(event.key) || /[^A-Za-z 0-9]/g.test(event.key)) event.preventDefault() 
	else return true
}

const trailerInCheck=(TRAILER_IN: string, props: any) =>{
	return TRAILER_IN &&
		startTripModel.isManagedEquipmentWithTrailerValidation(TRAILER_IN, props.loadDetails);
}

const arrivalDatCheck=(ARRIVAL_VALUE: string, currentDate: Date, isArrivalReadonly: boolean) =>{
	return ARRIVAL_VALUE &&
		new Date(ARRIVAL_VALUE) > currentDate &&
		!isArrivalReadonly;
}

const equipmentTrailerIN=(trailerIn: StopActivityProps, activity: StopActivityProps[], trailerOut: StopActivityProps) =>{
	if (trailerIn.equipmentFlow === EquipmentFlow.TRAILER_IN) {
		activity.push(trailerIn);
	}

	if (trailerOut.equipmentFlow === EquipmentFlow.TRAILER_OUT) {
		activity.push(trailerOut);
	}
}

const getStopDetailLongitude=(stopDetail: any): number=> {
	return stopDetail.longitude && parseFloat(stopDetail.longitude);
}

const getStopDetailLatitude=(stopDetail: any): number =>{
	return stopDetail.latitude && parseFloat(stopDetail.latitude);
}

async function getGEOTrackingStatus(props: any, stopInfo: StopInformation) {
	const shipment = IONICWrapper.details.vault && (await IONICWrapper.details.vault.getValue(DB_GPS_ACTIVATED_SHIPMENT));
	const gpsActivatedShipmentID = shipment && JSON.parse(shipment).shipmentID;
	if ((!gpsActivatedShipmentID ||
		(gpsActivatedShipmentID &&
			gpsActivatedShipmentID === props.loadDetails.shipmentId))) {
		stopInfo.geoTrackingStatus = true;
		stopInfo.gpsTrackingStatus = EGPSTrackingStatus.GPS_TRACKING_STARTED;
		props.GPSEnabledEvent();
	}
}

const trailerOutActivityCheck=(TRAILER_OUT_ACTIVITY: StopActivityProps | null): StopActivityProps | null =>{
	return TRAILER_OUT_ACTIVITY || null;
}

const trailerINActivityCheck=(TRAILER_IN_ACTIVITY: StopActivityProps | null): StopActivityProps | null=> {
	return TRAILER_IN_ACTIVITY || null;
}

const  startTripManagedTrailerValidation=(TRAILER_OUT: string, props: any) =>{
	return startTripModel.isManagedEquipmentWithTrailerValidation(TRAILER_OUT, props.loadDetails) &&
		!startTripModel.isOTypeStop(props.stopDetails) &&
		!TRAILER_OUT;
}

const isManagedTrailerValidation =(TRAILER_IN: string, props: any)=> {
	return startTripModel.isManagedEquipmentWithTrailerValidation(TRAILER_IN, props.loadDetails) &&
		!startTripModel.isOTypeStop(props.stopDetails) &&
		!TRAILER_IN;
}

const getArrivalReadOnlyValidation=(_arrival: Date, _departure: Date, isDepartureReadonly: boolean) =>{
	return _arrival > _departure && !isDepartureReadonly;
}

const isDepartureReadOnlyValidation=(_departure: Date, currentDate: Date, isDepartureReadonly: boolean) =>{
	return _departure > currentDate && !isDepartureReadonly;
}

const arrivalDataValidation=(ARRIVAL_VALUE: string, currentDate: Date)=> {
	return ARRIVAL_VALUE ? new Date(ARRIVAL_VALUE) : currentDate;
}
